import { analytics } from "../index.mjs";
const crossplay = {
  /** Track a `CrossplayStart` event. */
  trackCrossplayStart(payload) {
    analytics.pushEvent("CrossplayStart", payload);
  },
  /** Track a `CrossplayFinish` event. */
  trackCrossplayFinish(payload) {
    analytics.pushEvent("CrossplayFinish", {
      ...payload,
      wasInBackground: !!payload.wasInBackground
    });
  }
};
export {
  crossplay
};
